@if (confirm.visible()) {
<div class="confirm-overlay" role="dialog" aria-modal="true">
  <div class="confirm-card">
    <div class="confirm-body">
      <h3 class="confirm-title">{{ confirm.title() }}</h3>
      <p class="confirm-message">{{ confirm.message() }}</p>
    </div>

    <div class="confirm-actions">
      <app-button variant="ghost" (click)="onCancel()">
        {{ confirm.cancelLabel() }}
      </app-button>

      <app-button variant="primary" (click)="onConfirm()">
        {{ confirm.confirmLabel() }}
      </app-button>
    </div>
  </div>
</div>
}
